import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as fonts from 'view/styles/fonts';
import * as bp from 'view/styles/breakpoints';
import * as elevation from 'view/styles/elevation';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Wrapper = styled.header`
    top: 0;
    left: 0;
    width: 100%;
    position: fixed;
    background-color: ${token('elevation.surface.overlay', colors.N0)};
    ${elevation.e300}
    display: flex;
    justify-content: center;
`;

export const PageHeaderWrapper = styled.div`
    width: 100%;
    justify-content: center;
    padding: 0 ${token('space.500', '40px')};

    ${bp.fromLarge.css`
        max-width: ${grid.multiple(145).px};
    `}
`;

export const ButtonContainer = styled.div`
    max-width: ${grid.multiple(96).px};
    padding: ${token('space.050', '4px')};
`;

export const Title = styled.div`
    ${fonts.h600};
    margin-top: 0;
    margin-bottom: ${token('space.200', '16px')};

    ${bp.fromMobile.css`
    margin-bottom: 0;
`}
`;

export const PageHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: ${token('space.250', '20px')} 0;

    ${bp.fromMobile.css`
        flex-direction: row;
    `}
`;
